import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import CurrentMonthUsers from '@/components/v2/CurrentMonthUsers';
import { mixins } from 'vue-class-component';
import RouterParamsAppMixin from '../../../helpers/vue_mixins/RouterParamsAppMixin';
let DailyRegistrants = class DailyRegistrants extends mixins(RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.label = 'Daily Registrants';
        this.count = 0;
    }
};
DailyRegistrants = __decorate([
    Component({
        components: {
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
            CurrentMonthUsers,
        },
    })
], DailyRegistrants);
export default DailyRegistrants;
